<template>
    <div style="height:100%;overflow-y:hidden">
        <a-layout id="components-layout-demo-custom-trigger">
            <a-layout-sider v-model="collapsed" :trigger="null" collapsible style="overflow-y:auto">
            <router-link to="/index"  class="logo" style="display:block">
              <img src="../../static/logo.jpg" alt="">
            </router-link>
            <a-menu
                :default-selected-keys="['1']"
                mode="inline"
                theme="light"
                :inline-collapsed="collapsed"
                @openChange="onOpenChange"
                :openKeys="openKeys"
                >
                <a-menu-item key="1" >
                  <router-link to="/index">
                    <a-icon type="home" />
                    <span>首页</span>
                  </router-link>
                </a-menu-item>
                <a-sub-menu  v-for="item in menu" :key="item.id">
                    <span slot="title"><a-icon :type="item.icon" /><span>{{item.title}}</span></span>
                    <a-menu-item :key="option.id" v-for="option in item.children">
                      <router-link :to="option.href" >
                        {{option.title}}
                      </router-link>
                    </a-menu-item>
                </a-sub-menu>
            </a-menu>
            </a-layout-sider>
            <a-layout>
            <a-layout-header style="background: #fff; padding: 0 20px 0 0;display:flex;justify-content: space-between;">
          
                <a-icon
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="() => (collapsed = !collapsed)"
                />

                <div style="display:flex;align-items: center;">

                  <!-- 五卡话机 -->
                  <!-- {{iskf}} -->
                  <div v-if="pinfo.iskf==1&&pinfo.call_type==0" class="communicate-index" @click="call">
                    <h2>打个电话，联系客户 </h2>
                    <div class="tel-img">
                      <img src="../../static/svg/tel.svg" alt="">
                    </div>
                  </div>

                  <div class="sipbtn" @click="opensip" v-if="pinfo.iskf==1&&pinfo.call_type==1">
                    <a-icon type="customer-service" theme="filled"/>
                    <span>SIP电话</span>
                  </div>

                  <div style="margin-right:20px" v-if="pinfo.iskf==1&&pinfo.call_type==0">
                    <a target="_blank" href="http://yxk.18124.net/tools/index.html" style="display:flex;align-items:center">
                      <a-icon style="font-size:18px;margin-right:8px" type="question-circle" />
                      <span style="color:#333">电话助手下载</span>
                    </a>
                  </div>

                   <!-- <div style="margin-right:20px" v-if="pinfo.iskf==1&&pinfo.call_type==1">
                    <a target="_blank" href="http://yxk.18124.net/tools/index.html" style="display:flex;align-items:center">
                      <a-icon style="font-size:18px;margin-right:8px" type="question-circle" />
                      <span style="color:#333">SIP下载</span>
                    </a>
                  </div> -->

                  <a-dropdown overlayClassName="top-account-menu">
                    <a class="ant-dropdown-link" style="color:rgba(0,0,0,.65);">
                      <img src="../../static/head.png" class="mian-head" alt="">
                      {{pinfo.name}} <a-icon type="down" />
                    </a>
                    <div slot="overlay">
                      <div class="mian-user-head">
                          <img src="../../static/head.png" alt="">
                          <span>{{pinfo.name}}</span>
                          <router-link to="/person" >
                            个人中心<a-icon type="right" />
                          </router-link>
                      </div>
                      <a-menu>
                        <a-menu-item v-if="pinfo.item_title">{{pinfo.item_title}}</a-menu-item>
                        <a-menu-item v-else>--</a-menu-item>
                        <!-- {{pinfo.end_time}} -->
                         <a-menu-item >到期日期：{{pinfo.end_time | formatDate}}</a-menu-item>
                        <a-divider />
                        <a-menu-item @click="logout">退出登录</a-menu-item>
                      </a-menu>
                    </div>
                  </a-dropdown>
                </div>

            </a-layout-header>
            <a-layout-content
                :style="{  background: 'transparent', minHeight: '280px'}"
            >
                <router-view/>
            </a-layout-content>

            <!-- <a-layout-footer style="text-align:center">云销客 V 1.1.1</a-layout-footer> -->
            </a-layout>
        </a-layout>

         <!-- 五卡拨打电话 -->
    <div class="communicate-body" v-if="callshow">
      <div>
        <div class="communicate-head">
          <a-dropdown>
            <a class="ant-dropdown-link" >
              <img src="../../static/svg/drop.svg" alt="">
              <span>全网通话机</span>
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-for="(item,i) in calltypelist" :key="i">{{item}}</a-menu-item>
            </a-menu>
          </a-dropdown>

          <a-dropdown>
            <div class="agent-status" style="width: 70px; margin-top: 1px;" >
              SIM卡 {{currentsim}}<a-icon type="down" />
            </div>
            <a-menu slot="overlay"  @click="switchsim">
              <a-menu-item v-for="(item,i) in simlist" :key="i+1" :disabled="item">
                SIM卡{{i+1}}
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <div class="communicate-close"  @click="closecall">
            <img src="../../static/svg/close.svg" alt="">
          </div>

        </div>
      </div>



      <div class="communicate-body-oper exp" v-if="show2" id="blockpage">
          <a-spin />
      </div>

      <div class="communicate-body-oper" >
        <div class="communicate-oper" id="success" v-if="show3">
          <!-- v-if="show3" -->
          <div class="number-input">
            <img src="../../static/svg/call.svg" alt="">
            <a-input autocomplete="off" :rotate="180" v-model="phone" placeholder="请输入电话号码" style="font-size: 18px;"></a-input>
          </div> 

          <div class="communicate-key">
            <div class="keyboard-box" >
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='1'>1</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='2'>2</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='3'>3</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='4'>4</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='5'>5</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='6'>6</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='7'>7</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='8'>8</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='9'>9</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='*'>*</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='0'>0</span>
              <span class="keyboard-btn" @click='_handleKeyPress' data-num='#'>#</span>
            </div>

            <div class="communicate-call-btn" style="display: flex;align-items: center;justify-content: space-around;">
                <!-- <img style="cursor:point;margin-right:20px" src="../../static/svg/callbtn.svg"  @click="totel" alt=""> -->
                 <div class="telbtn" v-if="greentel">
                  <a-icon :rotate="180"   @click="totel" :style="{ color: '#fff' }" type="phone" theme="filled" />
                </div>

                <div class="telbtn" >
                  <a-icon :rotate="226" @click="endCall" :style="{ color: '#fff' }" type="phone" theme="filled" />
                </div>

               
                <!-- <a-button @click="totel"  :size="large" type="primary" shape="circle" icon="phone" /> -->

                <!-- <a-button @click="endCall" :size="large" type="danger" shape="circle" icon="phone" /> -->
            </div>
          </div>
        </div>

        <div class="fail-communicate-oper" v-if="show1" id="fail">
            <img src="/static/svg/fail_work.svg" alt="">
            <h1>目前话机无法正常工作，检查后重试</h1>
            <div>
              <p>1、检测话机是否正常运作，如断电、死机</p>
              <p>2、检测话机与电脑的连接是否正常，建议重新插拔USB设备，更换USB接口或数据线</p>
            </div>
        </div>

        <div v-if="show5" class="load-communicate">
          <div class="divinputforcall-uncall">
              <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
              <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
              <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
          </div>

          <div class="communicate-record">
            <h3 class="result-title">该号码匹配到多个对象：</h3>
            <span class="group-title">线索</span>
            <div v-for="(item,i) in xglist2" :key="i" class="group-info" >
              <span>{{item.contact_name}}</span>
            </div>

            <span v-if="xglist" class="group-title">线索</span>
            <div v-if="xglist" class="group-info" @click="gjclue(xglist.id)" >
              <span>{{xglist.clue_name}}</span>
              <span>--</span>
            </div>
          </div>
                  
        </div>

        <div v-if="show6" class="load-communicate">
           <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>

          <div class="communicateaddclue">
            <div class="addclue-info">
              {{phone}} 未匹配到客户
            </div>
            <div class="addclue-btn-group">
              <a-button @click="addcustom(phone)" type="primary" size="small">创建客户</a-button>
              <a-button @click="addclue(phone)" type="primary" size="small">创建线索</a-button>
            </div>
          </div>
        </div>

        <div v-if="show4" class="load-communicate">

            <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>



            <div class="communicate-record">
                <div @click="headback" class="head-back">
                  <a-icon type="left" />返回匹配列表
                </div>
                <div class="head-top">
                    <span>{{cluedetail.clue_name}}</span>
                    <div class="labelContainer">
                        <div v-if="cluedetail.tag.length>0">--</div>
                        <div v-else class="type-list"><span v-for="(item,idx) in cluedetail.tag" :key="idx">{{item}}</span></div>
                       
                    </div>
                      
                    <a-dropdown :trigger="['click']" v-model="typevisible">
                        <span class="ant-dropdown-link add-type">
                            + 标签
                        </span>
                        <div slot="overlay" class="tags-panel">
                            <div class="tags-panel-title">设置标签</div>
                             <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChangetype"
                            />

                            <div class="btnContent">
                                <a-button size="small" click="handleMenuClick">取消</a-button>
                                <a-button size="small" @click="settag" type="primary">确定</a-button>
                            </div>
                        </div> 
                    </a-dropdown>

                    <a-textarea v-model="gjcontent" placeholder="勤写跟进，多赢单，限定500个字" :rows="4" />
                    <a-button  class="savephone" @click="gjhandleOk">保存</a-button>
                    
                </div>
            </div>

        </div>

        <div v-if="show7" class="load-communicate">

            <div class="divinputforcall-uncall">
                <img style="width: 16px; height: 16px;" src="../../static/svg/down.svg"  @click="totel" alt="">
                <a-input style="font-size:18px" placeholder="请输入电话号码" autocomplete="off"></a-input>
                <img style="box-shadow: rgba(98, 205, 105, 0.6) 0px 0px 10px;border-radius: 50%;" src="../../static/svg/tel2.svg"  @click="totel" alt="">
            </div>

        </div>


      </div>

    </div>

        <!-- sip信息 -->
        <a-modal
        title="SIP信息"
        :visible="sipvisible"
        :footer="hide"
        :width="width"
        @cancel="handleCancel"
        >
          <a-descriptions :column="col">
            <a-descriptions-item label="IP/域名">
              {{pinfo.ccsipurl}}
            </a-descriptions-item>
            <a-descriptions-item label="坐席账号">
              {{pinfo.cc_id}}
            </a-descriptions-item>
            <a-descriptions-item label="坐席密码">
              {{pinfo.cc_password}}
            </a-descriptions-item>
            <a-descriptions-item label="使用说明">
              <a href="https://yh178.13524.net/yxkhelp/" target="_blanh">https://yh178.13524.net/yxkhelp/</a>
            </a-descriptions-item>
          </a-descriptions>
        </a-modal>
    </div>

</template>

<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

section.ant-layout-has-sider{height: 100%;}
section.ant-layout-has-sider .ant-layout-sider-children{background: #fff;box-shadow: 2px 0 8px 0 rgb(29 35 41 / 5%);}
</style>


<script>
import {formatDate} from '../utils/formate.js'
export default {

   filters: {
      //年-月-日
      formatDate (time) {
        time = time *1000
        time = parseInt(time)
        console.log(time)
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
  data() {
    return {
      collapsed: false,
      menu:[],
      col:1,
      width:'380px',
      sipvisible:false,
      hide:false,
      pinfo:"",

      openKeys: [''],

      callshow:false,
      currentsim:" ",
      simlist:[],
      show1:false,
      show3:false,
      show2:false,
      show5:false,
      show4:false,
      show6:false,
      show7:false,
      phone:"",
      siptype:2,

      iskf:"",

      greentel:true
    };
  },
  mounted(){
    this.fetch()
    this.personinfo()
    this.getdetail()
 
  },
  methods: {

    // 挂机
    endCall(){
      this.greentel=true
      hangup()
    },
    // 按键
    //处理按键
    _handleKeyPress(e) {
       let num = e.target.dataset.num;
      this.phone=this.phone+num

    },

    // 切卡
    switchsim(e) {
      changesim(e.key)
      var qkstatus=switchstatus()
      if(qkstatus==1){
        this.currentsim=e.key
        this.$message.success("SIM"+e.key+'切卡成功');
      }else{
        this.$message.error("切卡失败")
      }
    },

    totel(){
      var phone=this.phone
      var type=this.siptype
      this.greentel=false
      if(!phone.match(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)){
        return "请输入正确的手机号";
      }else{
        if(type==1){
             this.$axios.get("/api/sipcall",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                  phone:this.phone,
                  calltype:5,
                  callsource:2
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.show6=true
                    this.show3=false
                    this.$message.success(res.data.msg);
                }else if(res.data.code==4558){
                  this.$message.error(res.data.msg);
                }else{
                  this.show3=false
                  this.show5=true
                  this.xglist=res.data.info
                  this.xglist2=res.data.contact_list
                    // this.$message.error(res.data.msg);
                }
            })
        }else if(type==2){
          sendMsg("changesim")

          this.$axios.post('/api/telephoneblack/verifytelephoneblack',{
              telephone:phone
          },{
              headers: {
                  "token":localStorage.getItem('token'),
              }  
          }).then((res)=>{
              if(res.data.code==200){
                  zhihu(phone)
              }else{
                  this.$message.error(res.data.msg);
              }
          })
          // zhihu(phone)
          // this.$axios.get("/api/zhihuisdata",{
          //     headers: {
          //         "appid": this.appSet.appid,
          //         "appkey": this.appSet.appkey,
          //         "token":localStorage.getItem('token'),
          //     },
          //     params:{
          //         phone:this.phone,
          //     }
          // }).then((res)=>{
          //     if(res.data.code==2){
          //         this.show6=true
          //         this.show3=false
          //     }else{
          //         this.show3=false
          //         this.show5=true
          //         this.xglist=res.data.info
          //         this.xglist2=res.data.contact_list
          //         // this.$message.error(res.data.msg);
          //     }
          // })
        }
      }
    },

    // 五卡拨打
    call(){
        var simStatus= simlist()
        var nowsim=currsim()  
        if(simStatus!=undefined){
          simStatus=simStatus.split(",")
        }

        for(var i in simStatus){
          if(simStatus[i]==0){
            this.simlist[i]=true
          }else{
            this.simlist[i]=false
          }
        } 
        console.log("nowsim="+simStatus)
        this.currentsim=nowsim

        this.callshow=!this.callshow
        var link=linktype()
        if(link==2){
            // alert(link)
          this.show1=true,
          this.show2=false,
          this.show3=false,
          this.show6=false,
          this.show5=false,
          this.show4=false,
          this.show7=false
        }else{
          this.show3=true,
          this.show2=false,
          this.show1=false,
          this.show6=false,
          this.show5=false,
          this.show4=false,
          this.show7=false
        }
    },
     closecall(){
      this.callshow=false
    },


    // 加密方式
    getdetail(){
        this.$axios.post('/api/system/systemsetpage',{

        },{
            headers: {
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                localStorage.setItem('pwdtype', res.data.data.passtype);
            }else{
                this.$message.warning(res.data.msg); 
            }
            
        })

        // this.$axios.post('/api/system/editadmin',{
        //     aid:localStorage.getItem('aid'),
        //     IMEI:data.content.IMEI
        // },{
        //     headers: {
        //         "token":localStorage.getItem('token'),
        //     }
        // }).then((res)=>{
        //     if(res.data.code==200){
        //         this.$message.success(res.data.msg);
        //         this.$router.push({path: '/userlist'});
        //     }else{
        //         this.$message.error(res.data.msg); 
        //     }
        
        // })
      },
    onOpenChange(openKeys) {
      if (openKeys.length !== 0) {  
        this.openKeys = [openKeys[1]]
      } else {
        this.openKeys = ['']
      }
    },
    handleCancel(){
      this.sipvisible=false
    },
    // SIP信息
    opensip(){
      this.sipvisible=true
    },
    // 个人信息
    personinfo(){
       this.$axios.post('/api/system/adminpage',{
        },{
            headers: {
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
              localStorage.setItem('aid', res.data.data.aid);
              localStorage.setItem('gpid', res.data.data.gpid);
              localStorage.setItem('call_type', res.data.data.call_type);
              this.pinfo=res.data.data
              this.iskf=res.data.data.iskf
            }else{
              this.$message.warning(res.data.msg); 
            }
            
        })
    },
    fetch(){
      this.$axios.post('/api/system/mymenulist',{
        },{
            headers: {
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
              this.menu=res.data.data
            }else if(res.data.code==2011){
              localStorage.setItem('token', '');
              this.$router.push({ path:'/login'})
            }else{
              this.$message.warning(res.data.msg); 
            }
            
        })
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    logout(){
      localStorage.setItem('token', '');
      this.$router.push({ path:'/login'})
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/home.vue